import { configureStore } from "@reduxjs/toolkit";

import adminSlice from "./adminSlice";
import categorySlice from "./categorySlice";
import colorSlice from "./colorSlice";
import productSlice from "./productSlice";
import sizeSlice from "./sizeSlice";
import storeSlice from "./storeSlice";
import tabSlice from "./tabSlice";
import tagSlice from "./tagSlice";

const store = configureStore({
  reducer: {
    admin: adminSlice,
    store: storeSlice,
    category: categorySlice,
    color: colorSlice,
    tag: tagSlice,
    size: sizeSlice,
    product: productSlice,
    tab: tabSlice,
  },
});

export default store;
